/**
 * Created by staffanrantzow on 17/03/16.
 */

import * as types from './action-types';

export function openMenu () {
  return {
    type: types.OPEN_MAIN_MENU
  };
}

export function closeMenu () {
  return {
    type: types.CLOSE_MAIN_MENU
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/modules/main-menu/index.js
 **/